module.exports = __webpack_public_path__ + "static/media/Lotto99.cf006a54.png";